var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplesTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:peoples-two"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 3.6275C5.53664 3.94963 5.15818 4.37916 4.89696 4.8794C4.63574 5.37963 4.49954 5.93567 4.5 6.5C4.49987 7.10388 4.65599 7.69752 4.95318 8.2232C5.25037 8.74889 5.67852 9.18874 6.196 9.5M18 3.6275C18.4634 3.94963 18.8418 4.37916 19.103 4.8794C19.3643 5.37963 19.5005 5.93567 19.5 6.5C19.5005 7.06441 19.3644 7.62056 19.1032 8.12088C18.8419 8.62121 18.4634 9.05083 18 9.373M22 21V20.4C22 18.16 22 17.04 21.564 16.184C21.1805 15.4314 20.5686 14.8195 19.816 14.436M2 21V20.4C2 18.16 2 17.04 2.436 16.184C2.81949 15.4314 3.43139 14.8195 4.184 14.436M12 10C12.4596 10 12.9148 9.90947 13.3394 9.73358C13.764 9.55769 14.1499 9.29988 14.4749 8.97487C14.7999 8.64987 15.0577 8.26403 15.2336 7.83939C15.4095 7.41475 15.5 6.95963 15.5 6.5C15.5 6.04037 15.4095 5.58525 15.2336 5.16061C15.0577 4.73597 14.7999 4.35013 14.4749 4.02513C14.1499 3.70012 13.764 3.44231 13.3394 3.26642C12.9148 3.09053 12.4596 3 12 3C11.0717 3 10.1815 3.36875 9.52513 4.02513C8.86875 4.6815 8.5 5.57174 8.5 6.5C8.5 7.42826 8.86875 8.3185 9.52513 8.97487C10.1815 9.63125 11.0717 10 12 10ZM6 20V21H18V20C18 18.1365 18 17.2045 17.6955 16.469C17.2894 15.489 16.5106 14.7104 15.5305 14.3045C14.796 14 13.864 14 12 14C10.136 14 9.2045 14 8.4695 14.3045C7.98414 14.5055 7.54313 14.8002 7.17165 15.1717C6.80018 15.5431 6.50552 15.9841 6.3045 16.4695C6 17.2045 6 18.1365 6 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesTwo);
export default __webpack_public_path__ + "static/media/peoples-two.616d057adf24e99c9e662af6dd617470.svg";
export { ForwardRef as ReactComponent };